import React, { useEffect } from "react";
import { motion } from "framer-motion";

const ErrorPage=()=>{
      useEffect(() => {
                    document.title =
                      "Page Not Found | Dr. Jigar Gor Ayurvedic Clinic";
                
                    const metaDesc = document.querySelector("meta[name='description']");
                    if (metaDesc) {
                      metaDesc.setAttribute(
                        "content",
                        "The page you are looking for could not be found. Return to Dr. Jigar Gor's homepage for professional Ayurvedic treatment and Panchkarma clinic assistance."
                      );
                    }
                
                   const canonical = document.querySelector("link[rel='canonical']");
                  if (canonical) {
                    canonical.setAttribute("href", "https://msayurved.com/404");
                  }
                
                  const ogTitle = document.querySelector("meta[property='og:title']");
                  if (ogTitle) {
                    ogTitle.setAttribute(
                      "content",
                      "Page Not Found | Dr. Jigar Gor Ayurvedic Clinic"
                    );
                  }
                
                    const ogDesc = document.querySelector("meta[property='og:description']");
                  if (ogDesc) {
                    ogDesc.setAttribute(
                      "content",
                      "The page you are looking for could not be found. Return to Dr. Jigar Gor's homepage for professional Ayurvedic treatment and Panchkarma clinic assistance."
                    );
                  }
                
                 const ogUrl = document.querySelector("meta[property='og:url']");
                  if (ogUrl) {
                    ogUrl.setAttribute("content", "https://msayurved.com/404");
                  }
                
                    const ogImage = document.querySelector("meta[property='og:image']");
                  if (ogImage) {
                    ogImage.setAttribute(
                      "content",
                      "https://msayurved.com/Images/home.webp"
                    );
                  }
                
                    const twitterTitle = document.querySelector("meta[name='twitter:title']");
                  if (twitterTitle) {
                    twitterTitle.setAttribute(
                      "content",
                      "Page Not Found | Dr. Jigar Gor Ayurvedic Clinic"
                    );
                  }
                
                    const twitterDesc = document.querySelector(
                    "meta[name='twitter:description']"
                  );
                  if (twitterDesc) {
                    twitterDesc.setAttribute(
                      "content",
                      "The page you are looking for could not be found. Return to Dr. Jigar Gor's homepage for professional Ayurvedic treatment and Panchkarma clinic assistance."
                    );
                  }
                
                  const twitterImage = document.querySelector("meta[name='twitter:image']");
                  if (twitterImage) {
                    twitterImage.setAttribute(
                      "content",
                      "https://msayurved.com/Images/home.webp"
                    );
                  }
                  }, []);
    return(
        <>
     <motion.section
  className="error-page container"
  initial={{
    opacity: 0,
    y: 40,
  }}
  whileInView={{
    opacity: 1,
    y: 0,
  }}
  viewport={{
    once: true,
    amount: 0.2,
  }}
  transition={{
    duration: 1.2,
    ease: "easeOut",
  }}
>

  <motion.h1
    className="hero-heading"
    initial={{
      opacity: 0,
      y: 30,
    }}
    whileInView={{
      opacity: 1,
      y: 0,
    }}
    viewport={{
      once: true,
    }}
    transition={{
      duration: 1,
      delay: 0.2,
      ease: "easeOut",
    }}
  >
    404 <br />
    Page Not Found!
  </motion.h1>

  <motion.p
    className="section-text"
    initial={{
      opacity: 0,
      y: 20,
    }}
    whileInView={{
      opacity: 1,
      y: 0,
    }}
    viewport={{
      once: true,
    }}
    transition={{
      duration: 1,
      delay: 0.45,
      ease: "easeOut",
    }}
  >
    The page you are looking for may have been removed,
    renamed, or is temporarily unavailable.
    <br />
    Please return to the homepage or explore another section
    of our website.
  </motion.p>

  <motion.a
    className="primary-btn"
    href="/"
    initial={{
      opacity: 0,
      y: 20,
    }}
    whileInView={{
      opacity: 1,
      y: 0,
    }}
    viewport={{
      once: true,
    }}
    transition={{
      duration: 0.9,
      delay: 0.7,
      ease: "easeOut",
    }}
    whileHover={{
      y: -3,
      scale: 1.02,
    }}
    whileTap={{
      scale: 0.97,
    }}
  >
    Back to Homepage
  </motion.a>

</motion.section>
        </>
    )
}
export default ErrorPage;